import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["modelType", "modelId", "autoload", "filter", "onCompose", "onLoad", "onLoaded", "user", "api", "children"];
import React, { useEffect, useMemo, useState } from "react";
import useComments from "./useComments";
import { UNLOADED, LOADING, LOADED, useCheckLoad, getComments, isLoading, isLoaded } from "./Context";
import CommentList from "./List";
import { getArgs } from "./common";

/**
 * Consumes or holds comments, optionally loads them for given model type and id, and then
 * either passes them on to its children (callback or element) or renders a `CommentList`.
 * @param {{
 *  modelType: string,
 *  modelId: number,
 *  autoload: boolean|object,
 *  filter: object,
 *  lightboxId: number,
 *  lightboxArgs: object,
 *  onLoad: (load: () => void) => void,
 *  onLoaded: () => void,
 *  children: any
 * }}
 */
import { jsx as _jsx } from "react/jsx-runtime";
export var CommentContainer = function CommentContainer(_ref) {
  var modelType = _ref.modelType,
    modelId = _ref.modelId,
    autoload = _ref.autoload,
    filter = _ref.filter,
    onCompose = _ref.onCompose,
    onLoad = _ref.onLoad,
    onLoaded = _ref.onLoaded,
    user = _ref.user,
    api = _ref.api,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var context = useComments(user, api);
  var dispatch = context.dispatch;

  // Loading
  var _useState = useState(autoload === true),
    _useState2 = _slicedToArray(_useState, 2),
    load = _useState2[0],
    setLoad = _useState2[1];
  var handleLoad = function handleLoad() {
    return onLoad ? onLoad(function () {
      return setLoad(true);
    }) : setLoad(true);
  };
  var args = getArgs(modelType, modelId, filter, !load && autoload);
  var filterArgs = getArgs(modelType, modelId, filter);
  var modelArgs = getArgs(modelType, modelId);
  useCheckLoad(context, args, load || autoload);

  // Loaded callback
  var loaded = isLoaded(context, args);
  useEffect(function () {
    loaded && onLoaded && onLoaded();
  }, [loaded, onLoaded]);

  // Child props
  var commentProps = useMemo(function () {
    var handler = function handler(type) {
      return function (comment) {
        return dispatch({
          type: type,
          comment: _objectSpread(_objectSpread({}, comment), modelArgs)
        });
      };
    };
    var comments = getComments(context, filterArgs);
    var all = getComments(context, modelArgs);
    return {
      comments: comments,
      loaded: isLoading(context, args) ? LOADING : comments.length === all.length && isLoaded(context, modelArgs) ? LOADED : UNLOADED,
      onAdd: handler("add"),
      onEdit: handler("edit"),
      onDelete: handler("delete"),
      onLike: handler("like")
    };
  }, [context, args]);
  props = _objectSpread(_objectSpread(_objectSpread({}, props), commentProps), {}, {
    user: user,
    onCompose: onCompose,
    onLoad: handleLoad
  });
  if (children === undefined) {
    return /*#__PURE__*/_jsx(CommentList, _objectSpread({}, props));
  } else if (typeof children === "function") {
    return children(props);
  } else {
    return children;
  }
};
export default CommentContainer;
//# sourceMappingURL=Container.js.map